import {FlagProps} from 'platform/components';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {BusinessCaseInternalType, PurchaseVehicleType} from '@dms/api/finance';
import i18n from '@dms/i18n';

import {LiteralUnionAutocomplete, Nullish} from 'shared/web';

export const getBusinessCaseTradeTypeFlag = (
  type: LiteralUnionAutocomplete<PurchaseVehicleType | BusinessCaseInternalType> | Nullish
): Pick<FlagProps, 'colorScheme' | 'label'> | undefined =>
  match<
    LiteralUnionAutocomplete<PurchaseVehicleType | BusinessCaseInternalType> | Nullish,
    Pick<FlagProps, 'colorScheme' | 'label'> | undefined
  >(type)
    .with(
      'BROKERAGE',
      'PURCHASE_BROKERAGE',
      always({
        colorScheme: 'teal',
        label: i18n.t('entity.vehicle.labels.typeBrokerage'),
      })
    )
    .with(
      'IN_STOCK',
      'BUYING',
      always({
        colorScheme: 'yellow',
        label: i18n.t('entity.vehicle.labels.typeInStock'),
      })
    )
    .otherwise(always(undefined));
